import { render, staticRenderFns } from "./user-profile.vue?vue&type=template&id=7904801e"
import script from "./user-profile.vue?vue&type=script&lang=js"
export * from "./user-profile.vue?vue&type=script&lang=js"
import style0 from "./user-profile.vue?vue&type=style&index=0&id=7904801e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports